/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import metadata from './DiscountSurchargesLossAccordion.metadata.json5';
import styles from './DiscountSurchargesLossAccordion.module.scss'


const DiscountSurchargesLossAccordion = props => {
    const {
        onTabChangeObj
    } = props;

    const getChargeableCell = useCallback((item)=>{
        return item?.chargeable ? "Yes" : "No"
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {           
            className:styles.fieldStyle
        },
        priorLossesListTable: {
            data: _.get(onTabChangeObj, 'latestJobPolicyPeriod.priorLosses_TFPA')
        },
        homeSecurityDevice: {
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.dwellingHomeSecurityDeviceCredit_Ext') ? 'Yes' : 'No'
        }
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getChargeableCell
        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={onTabChangeObj}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        // componentMap={resolvers.resolveComponentMap}
        />
    );
};


DiscountSurchargesLossAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({})
};
export default DiscountSurchargesLossAccordion;
